import Bodoni72Smallcaps from "../assets/fonts/Bodoni 72 Smallcaps Book.ttf";
import { StyleSheet, Dimensions } from "react-native";

const { width, height } = Dimensions.get('window');

// Get device pixel ratio to detect high-DPI displays
const pixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

// Calculate "logical" width (actual perceived size)
const logicalWidth = width / pixelRatio;

// Responsive breakpoints based on logical size + physical characteristics
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
// For high-DPI use logical width or smaller threshold
const isLaptop = (width >= 1024 && width < 1920) || (pixelRatio > 1.5 && width < 1920);
const isLargeDesktop = width >= 1920;

const fontFamilies = {
	Bodoni72Smallcaps: "Bodoni72Smallcaps",
};

const styles = StyleSheet.create({
	body: {
		flex: 1,
		position: "relative",
		backdropFilter: "blur(10px)",
		overflow: "auto",
		overflowX: "hidden",
		minHeight: "100vh",
		width: "100vw",
	},
	section: {
		flex: 1,
		minHeight: "100vh",
		width: "100vw",
		overflowX: "hidden",
		zIndex: 1,
		justifyContent: "flex-start",
		alignContent: "center",
		paddingBottom: isMobile ? 80 : isTablet ? 100 : 120,
		position: "relative",
	},
	backgroundImage: {
		flex: 1,
		resizeMode: "cover",
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		width: "100%",
		height: "100%",
		minHeight: "100vh",
		backgroundSize: "cover",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundAttachment: "fixed",
		zIndex: 0,
	},
	headerBar: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		paddingHorizontal: isMobile ? 0 : isTablet ? 50 : 100,
		paddingTop: isMobile ? 15 : isTablet ? 30 : 50,
		position: "relative",
		width: "100%",
		zIndex: 98,
	},
	logoArea: {
		flex: 1,
		flexDirection: "row",
		justifyContent: "space-between",
		backgroundColor: "transparent",
		maxHeight: isMobile ? 30 : isTablet ? 40 : 50,
		height: 62,
		marginTop: 10,
	},
	logoText: {
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontWeight: "normal",
		fontSize: isMobile ? 18 : isTablet ? 25 : 40,
		marginLeft: isMobile ? 25 : 0,
		textAlign: "left",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	loginArea: {
		marginRight: isMobile ? 250 : isTablet ? 250 : 0,
		flex: 1,
		flexDirection: "row",
		backgroundColor: "transparent",
		maxHeight: 50,
	},
	logoutButton: {
		width: 208,
		height: 62,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 99,
		marginLeft: isMobile ? 15 : isTablet ? 180 : 350,
		top: isMobile ? -10 : 0,
	},
	loginButton: {
		width: 208,
		height: 62,
		backgroundColor: "transparent",
		alignItems: "center",
		justifyContent: "center",
		boxShadowOffset: { width: 3, height: 3 },
		boxShadowRadius: 6,
		boxShadowColor: "rgba(0, 0, 0, 0.16)",
		zIndex: 99,
		marginLeft: isMobile ? 15 : isTablet ? 180 : 350,
		top: isMobile ? -10 : 0,
	},
	loginButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		lineHeight: 30,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	cancelButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		textAlign: "center",
		color: "#e4e4e4",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
		paddingRight: 90,
	},
	signOutButtonText: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 20 : isTablet ? 25 : 28,
		textAlign: "center",
		color: "red",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},

	buttonText: {
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: isMobile ? 18 : isTablet ? 22 : isLaptop ? 24 : 30,
		lineHeight: 30,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
	},
	welcomeArea: {
		marginTop: isMobile ? -100 : isTablet ? 15 : 20,
		width: "100%",
		justifyContent: "center",
		alignItems: "center",
		paddingHorizontal: isMobile ? 20 : 0,
	},
	descriptionArea: {
		width: "100%",
		height: "auto",
		backgroundColor: "transparent",
		paddingHorizontal: isMobile ? 20 : isTablet ? 45 : 100,
		paddingBottom: isMobile ? 18 : isTablet ? 23 : 35,
		marginBottom: isMobile ? 10 : isTablet ? 15 : 25,
	},
	welcomeText: {
		width: isMobile ? "90vw" : isTablet ? "80vw" : "75vw",
		minHeight: isMobile ? 70 : isTablet ? 90 : 100,
		height: "auto",
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		fontSize: isMobile ? 40 : isTablet ? 65 : isLaptop ? 75 : 110,
		marginTop: isMobile ? 130 : isTablet ? 45 : isLaptop ? 100 : 200,
		lineHeight: isMobile ? 48 : isTablet ? 75 : isLaptop ? 85 : 120,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 5, height: 3 },
		textShadowRadius: 4,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		alignSelf: "center",
	},

	descriptionText: {
		width: isMobile ? "85vw" : isTablet ? 500 : isLaptop ? "55vw" : "45vw",
		minHeight: isMobile ? 90 : isTablet ? 135 : isLaptop ? 95 : 100,
		height: "auto",
		fontFamily: "Orpheus Pro",
		fontWeight: "500",
		fontSize: isMobile ? 18 : isTablet ? 32 : isLaptop ? 32 : 45,
		lineHeight: isMobile ? 28 : isTablet ? 40 : isLaptop ? 42 : 55,
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		textAlign: "center",
		alignSelf: "center",
		paddingTop: isMobile ? 10 : isTablet ? 10 : 18,
	},

	buttonsContainer: {
		flexDirection: isMobile ? "column" : "row",
		maxWidth: isMobile ? 380 : isTablet ? 750 : isLaptop ? 1000 : 1400,
		alignSelf: "center",
		marginTop: isMobile ? 18 : isTablet ? 18 : isLaptop ? -100 : -300,
		flex: 1,
		position: "relative",
		zIndex: 5,
		justifyContent: "center",
		alignItems: isMobile ? "center" : "flex-start",
	},

	buttonArea: {
		marginHorizontal: isMobile ? 35 : isTablet ? 45 : 45,
		flexDirection: "column",
		justifyContent: "center",
		alignContent: "center",
		alignSelf: "center",
		zIndex: 1000,
		marginBottom: isMobile ? 18 : 0,
	},

	button: {
		width: isMobile ? 270 : isTablet ? 290 : isLaptop ? 300 : 340,
		height: isMobile ? 53 : isTablet ? 58 : isLaptop ? 60 : 70,
		marginBottom: isMobile ? 18 : 0,
		backgroundColor: "#4c956c",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: 40,
	},

	buttonDescription: {
		width: isMobile ? 90 : isTablet ? 150 : 240,
		height: isMobile ? 80 : isTablet ? 90 : 98,
		paddingTop: isMobile ? 11 : isTablet ? 14 : 16,
		fontFamily: "Orpheus Pro",
		fontWeight: "bold",
		fontSize: isMobile ? 15 : isTablet ? 17 : 19,
		lineHeight: isMobile ? 22 : isTablet ? 26 : 29,
		textAlign: "center",
		color: "#fefde1",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.16)",
		alignSelf: "center",
	},

	// Styles for the custom modal
	centeredView: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center",
		marginTop: 22,
	},
	modalView: {
		padding: 20,
		backgroundColor: "#fefde2",
		borderRadius: 10,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		margin: 20,
		alignItems: "center",
		shadowOpacity: 0.25,
		shadowRadius: 4,
		elevation: 5,
	},
	buttonOpen: {
		backgroundColor: "#4c956c",
		borderRadius: 20,
		padding: 10,
		elevation: 2,
		marginTop: 15,
	},
	buttonClose: {
		backgroundColor: "red",
		borderRadius: 20,
		padding: 10,
		elevation: 2,
		marginTop: 15,
	},
	textStyle: {
		fontFamily: "Orpheus Pro",
		fontSize: 16,
		textAlign: "center",
		color: "#fefde2",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
	},
	modalText: {
		fontFamily: "Orpheus Pro",
		fontSize: 20,
		textAlign: "center",
		color: "#4c956c",
		textShadowOffset: { width: 3, height: 3 },
		textShadowRadius: 6,
		textShadowColor: "rgba(0, 0, 0, 0.09)",
		marginHorizontal: 25,
	},
	buttonGreen: {
		backgroundColor: "#4c956c",
		paddingVertical: 10,
		paddingHorizontal: 20,
		borderRadius: 20,
		marginTop: 10,
		width: "80%",
		alignItems: "center",
	},
	buttonRed: {
		backgroundColor: "red",
		paddingVertical: 10,
		paddingHorizontal: 20,
		borderRadius: 20,
		marginTop: 10,
		width: "80%",
		alignItems: "center",
	},
	overlayBlur: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backdropFilter: "blur(25px)",
		zIndex: 1,
	},
	blurredContainer: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backdropFilter: "blur(10px)",
		zIndex: 9999,
	},
	ribbonContainer: {
		position: 'fixed',
		bottom: isMobile ? '23%' : 160,
		right: isMobile ? 20 : 40,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: "#4c956c",
		padding: 10,
		borderRadius: isMobile ? 30 : 10,
		zIndex: 9999,
		width: isMobile ? 40 : 175,
		height: isMobile ? 40 : 'auto',
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8
	},
	ribbonButton: {

	},
	ribbon1: {
		position: 'absolute',
		bottom: '-100%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon2: {
		position: 'absolute',
		bottom: '-200%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon3: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100, 
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon4: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon5: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbon6: {
		position: 'absolute',
		bottom: '-300%',
		transition: 'bottom 0.5s ease-out',
		backgroundColor: '#4c956c',
		padding: 10,
		borderRadius: 10,
		zIndex: 100,
		width: 175,
		alignItems: "center",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	ribbonText: {
		color: '#FFFFFF',
		fontWeight: 'bold',
		textAlign: 'center',
	},
	resourcesOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(76, 149, 108, 0.95)',
		zIndex: 10000,
		justifyContent: 'center',
		alignItems: 'center',
	},
	resourcesOverlayCloseButton: {
		position: 'absolute',
		top: 20,
		right: 20,
	
		width: 40,
		height: 40,
		borderRadius: 20,
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 10001,
	},
	resourcesOverlayCloseButtonText: {
		fontSize: 18,
		fontWeight: 'bold',
		color: '#FEFCE0',
	},
	resourcesOverlayContent: {
		width: '80%',
		maxHeight: '80%',
		borderRadius: 10,
		paddingBottom: 100,
		alignItems: 'center',
	},
	resourcesOverlayTitle: {
		fontSize: 24,
		fontWeight: 'bold',
		color: '#FEFCE0',
		marginBottom: 20,
		fontFamily: "Bodoni72Smallcaps",
	},
	resourcesOverlayItem: {
		width: '100%',
		padding: 15,
		borderRadius: 10,
		marginBottom: 10,
		alignItems: 'center',
	},
	resourcesOverlayItemText: {
		fontSize: 18,
		color: '#FEFCE0',
		textAlign: 'center',
		fontWeight: 'bold',
		fontFamily: "Bodoni72Smallcaps",
	},

	// Desktop Resources Modal (new)
	desktopResourcesButton: {
		position: 'fixed',
		bottom: isMobile ? '23%' : 160,
		right: isMobile ? 20 : 40,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: "#4c956c",
		padding: 10,
		borderRadius: isMobile ? 30 : 10,
		zIndex: 9999,
		width: isMobile ? 40 : 175,
		height: isMobile ? 40 : 'auto',
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.5,
		shadowRadius: 5,
		elevation: 8,
	},
	desktopResourcesButtonText: {
		color: '#FFFFFF',
		fontWeight: 'bold',
		textAlign: 'center',
		width: 100,
	},
	desktopResourcesOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		zIndex: 9998,
		backdropFilter: "blur(5px)",
	},
	desktopResourcesPanel: {
		position: 'fixed',
		top: 0,
		right: 0,
		width: Math.min(300, width * 0.8),
		maxWidth: '80vw',
		height: '100%',
		backgroundColor: 'rgba(76, 149, 108, 0.95)',
		zIndex: 9999,
		boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.3)',
		padding: 20,
		display: 'flex',
		flexDirection: 'column',
		overflowX: 'hidden',
	},
	desktopResourcesCloseButton: {
		position: 'absolute',
		top: 20,
		right: 20,
		width: 40,
		height: 40,
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 10000,
	},
	desktopResourcesCloseButtonText: {
		fontSize: 24,
		fontWeight: 'bold',
		color: '#FEFCE0',
	},
	desktopResourcesTitle: {
		fontSize: 30,
		fontWeight: 'bold',
		color: '#FEFCE0',
		marginTop: 40,
		marginBottom: 30,
		fontFamily: fontFamilies.Bodoni72Smallcaps,
		textAlign: 'center',
	},
	desktopResourcesContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginBottom: 40,
		overflowY: 'auto',
	},
	desktopResourcesItem: {
		width: '100%',
		padding: 15,
		marginBottom: 10,
		borderRadius: 10,
		alignItems: 'center',
		transition: 'transform 0.2s ease',
	},
	desktopResourcesItemHover: {
		transform: [{ scale: 1.05 }],
		backgroundColor: 'rgba(255, 255, 255, 0.1)',
	},
	desktopResourcesItemText: {
		fontSize: 20,
		color: '#FEFCE0',
		textAlign: 'center',
		fontWeight: 'bold',
		fontFamily: fontFamilies.Bodoni72Smallcaps,
	},
});

export default styles;
